import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-config',
	path: '/secure/admin/ConfigureFieldLayout([!%]?[\\w]*).jspa',
};
